import {useEffect, useState, useRef} from 'react';
import {getUsers} from "../../api/Api";
import {AutoComplete, Button, Col, Row} from "antd";

export const UserSelectWidget = ({type, user, setUser, setComponentActive, onApiFail, altText, props}) => {
    const [users, setUsers] = useState([]);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState(undefined);
    const [active, setActive] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        getUsers().then(result => {
            setUsers(result.map(r => {
                return {
                    ...r,
                    key: r.id,
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail]);

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = users.filter(line => {
            const ltext = text.toLowerCase();
            return (line.username.toLowerCase().includes(ltext) || line.firstname.toLowerCase().includes(ltext)
                || line.lastname.toLowerCase().includes(ltext));
        }).map(val => {
            return {
                value: `${val.firstname} ${val.lastname} - ${val.username}`,
                item: val,
                key: val.key,
            }
        });
        setOptions(newOptions)
    }

    const select = (val, option) => {
        // console.log(`select ${val} ${JSON.stringify(option)}`);
        if (setUser) {
            setUser(option.item);
        }
        setActive(false);
        if (setComponentActive) setComponentActive(false);
    }

    const onBlur = () => {
        setActive(false);
        if (setComponentActive) setComponentActive(false);
    }

    const onClick = () => {
        setActive(true);
        if (setComponentActive) setComponentActive(true);
        setTimeout(() => {
            inputRef.current.focus();
        }, 20)
    }

    const alternate = altText ? altText : 'user';

    const rowStyle = {
        marginTop: "5px",
        marginBottom: "5px"
    }

    const autoCompleteStyle = {
        width: 350
    }

    let name;
    if ((user === undefined) || (user === null)) {
        name = "Not Assigned"
    } else {
        name = `${user.firstname} ${user.lastname}`;
    }

    if (active) {
        return <div>
            <Row style={rowStyle}>
                <Col span={8} onBlur={onBlur}>
                    <AutoComplete placeholder={alternate} style={autoCompleteStyle} options={options} onSelect={select}
                                  onSearch={onSearch} value={value} onChange={onChange} onBlur={onBlur} ref={inputRef}/>
                </Col>
            </Row>
        </div>
    } else {
        if (type === "button") {
            return <Button onClick={onClick}>Add Follower</Button>
        }
        return <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onClick}>
            {name}
        </div>
    }
}